import { render, staticRenderFns } from "./tableItemEdit.vue?vue&type=template&id=8e3136c8&scoped=true"
import script from "./tableItemEdit.vue?vue&type=script&lang=js"
export * from "./tableItemEdit.vue?vue&type=script&lang=js"
import style0 from "./tableItemEdit.vue?vue&type=style&index=0&id=8e3136c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e3136c8",
  null
  
)

export default component.exports